import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects"
import { ADD_PROFILEPHOTO_START } from "./actionTypes"

import { addProfilePhotoSuccess, addProfilePhotoFailure } from "./action"

import { addProfilePhotoAPI } from "./api"

function* addProfilePhotoAsync(action) {
  try {
    const imagedata = action.payload
    const response = yield call(addProfilePhotoAPI, imagedata)

    if (response.status === 200) {
      const data = yield response
      yield put(addProfilePhotoSuccess(data))
    } else {
      yield put(
        addProfilePhotoFailure(
          "An error occurred. while updating Image Please try again"
        )
      )
    }
  } catch (error) {
    yield put(
      addProfilePhotoFailure(
        "An error occurred. while updating Image Please try again"
      )
    )
  }
}

function* AddProfilePhoto() {
  yield takeEvery(ADD_PROFILEPHOTO_START, addProfilePhotoAsync)
}

function* AddProfilePhotoSaga() {
  yield all([fork(AddProfilePhoto)])
}
export default AddProfilePhotoSaga
